import { useEffect } from 'react';

/**
 * Handles the /threat-hunt route.
 * Navigates to /threat-hunt served by the auth gateway (same-origin).
 */
export default function ThreatHuntRedirect() {
  useEffect(() => {
    window.location.replace('/threat-hunt');
  }, []);

  return null;
}
